import { getAggregateError, } from "@bracket/catch";
import { contract, multiCaller, } from "@bracket/chainography/contracts";
import type { EthereumAddress, } from "@bracket/types";
import { wagmiConfig as config } from "@wagmiconfig";


export declare type GetBalancesProps = {
	wallet: EthereumAddress;
	wrapper: EthereumAddress;
	vault: EthereumAddress;
}

export const getBalances = async ({
	wallet,
	wrapper,
	vault,
}: GetBalancesProps) => {

	const [ [ vault_balance, wrapper_balance, ], errors, ] = await multiCaller<[bigint, bigint]>(config, [
		contract("ERC20", "balanceOf", vault, wallet),
		contract("ERC20", "balanceOf", wrapper, wallet),
	]);

	if(errors) {
		throw getAggregateError(errors, `Wrap:Resolvers::getBalances failed to get balances of wallet "${wallet}" or wrapper "${wrapper}"`);
	}

	return {
		wrapper_balance,
		vault_balance,
	}

}

